// Module
var code = `<a class="home_news_button" href="/" onclick="event.preventDefault(),navigateLink(this)"><span class="home_news_button_title">#TITLE</span><span class="home_news_button_time">#TIME_SINCE_POST</span></a>`;
// Exports
export default code;